export const HeaderType = {
    Full: 'full',
    Minimal: 'minimal',
    None: 'none'
};

export const FooterType = {
    Full: 'full',
    None: 'none'
};